import "angular"; 
import "angular-resource";
import "angular-ui-router";
import oauthController from "./OAUTHController";
import oauthFactory from "./OAUTHFactory.js";
import StateInterceptor from "../core/StateInterceptor";

// eslint-disable-next-line no-undef
var oauth = angular.module('oauth', ['ngResource', 'ui.router', 'focusDirectives']);
oauth.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('StateInterceptor');
}]);
oauth.controller('oauthController', oauthController);
oauth.factory('StateInterceptor', StateInterceptor);
oauth.factory('oauthFactory', oauthFactory);

export default oauth;
